export enum injectPosition {
	BEFORE_BEGIN	= 'beforebegin',
	AFTER_BEGIN		= 'afterbegin',
	BEFORE_END		= 'beforeend',
	AFTER_END		= 'afterend'
}

export enum slotType {
	IN_VIEW	= 'inview',
	STATIC 	= 'static',
	LAZY 	= 'lazy'
}

export enum deviceType {
	DESKTOP	= 'desktop',
	TABLET	= 'tablet',
	MOBILE	= 'mobile'
}
